const { useLocation } = require("react-router-dom/cjs/react-router-dom");

export const PARAMS = {
    get(key) {
        const { search } = useLocation();
        const queryParams = new URLSearchParams(search);
        return queryParams.get(key);
    }
}